<template>
	<c-dialog ref="dialog"height="450" width="550" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
            <c-form-item label="审批结果" required>
                <c-radio-group name="withdraw_status" :options="withdrawStatusDic" v-model="withdrawStatus"></c-radio-group>
            </c-form-item>
            <c-form-item label="打款方式" v-if="withdrawStatus == 3" required :tip="payTypeTip">
                <c-radio-group name="withdraw_pay_type" :options="payTypeOptions" v-model="withdrawPayType"></c-radio-group>
            </c-form-item>
            <c-form-item label="打款凭证" v-if="withdrawStatus == 3 && withdrawPayType == 0" required>
                <c-upload-file name="pay_voucher_img_url" v-model="payVoucherUrl" type="image"></c-upload-file>
            </c-form-item>
			<c-form-item label="驳回原因" required v-if="withdrawStatus == 6">
                <c-input type="textarea" name="reject_reason" maxlength="500"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'withdrawAudit',

	components: {
	},
	
	data() {
		return {
            //审批结果
            withdrawStatusDic: [
                {name: '审批通过',value: 3,color: 'blue'},
                {name: '审批驳回',value: 6,color: 'red'},
            ],
            withdrawStatus:3,         //审批状态
            withdrawPayTypeDic: [
                {name: '线下打款',value: 0,color: 'blue'},
                {name: '通联打款',value: 1,color: 'red'},
            ],
            withdrawPayType:undefined,        //支付方式
            signContractEnabled:true,         //提现申请人是否已签约（未签约时隐藏通联打款）
            payVoucherUrl:'',                //打款凭证
            withdrawApplyIds:[]              //提现申请ID
		}
	},

	computed: {
		...mapState(['systemConfig', 'userTypeDic', 'saasInfo', 'pricingTypeDic']),
        //打款方式选项（提现申请人未签约时隐藏通联打款）
        payTypeOptions() {
            return this.signContractEnabled ? this.withdrawPayTypeDic : this.withdrawPayTypeDic.filter(item => item.value != 1);
        },
        //打款方式提示语
        payTypeTip() {
            if (this.withdrawStatus != 3){
                return '';
            }
            if (!this.signContractEnabled){
                return '所选提现申请的提现申请人尚未完成通联签约，仅支持线下打款';
            }
            return this.withdrawPayType == 1 ? '使用通联打款，每单将收取1元服务费，由商户主账号承担' : '';
        }
	},

	methods: {
		/*********打开编辑框，初始化**********/
        open(ids, signContract) {
            this.$refs.form.clear();
            this.signContractEnabled = signContract !== false;
            this.withdrawPayType = undefined;          //重置打款方式，避免上次选择残留
            this.$refs.form.set({
                withdraw_status:this.withdrawStatus
            });
            if (ids) {
                this.withdrawApplyIds = ids;
            }
			//填充form表单
			this.$refs.dialog.open({
				title: '提现申请审批'
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: '/withdraw/audit',
				rule: {
                    withdraw_status: '请选择审批结果',
                    withdraw_pay_type: [{
                        type: 'empty',
                        message: '请选择打款方式',
                        skip: () => {
                            return this.withdrawStatus == 6;
                        }
                    }],
                    pay_voucher_img_url: [{
                        type: 'empty',
                        message: '请上传打款凭证',
                        skip: () => {
                            return this.withdrawStatus == 6 || this.withdrawPayType == 1;
                        }
                    }],
                    reject_reason: [{
                        type: 'empty',
                        message: '请输入审核驳回原因',
                        skip: () => {
                            return this.withdrawStatus == 3;
                        }
                    }]
				},
				dataFormatter: data => {
                    data.ids = this.withdrawApplyIds;
                    return data;
				},
				success: (data, res) => {
					next();
                    this.$message({
                        message: '提现审批成功',  // 提示内容,
                        type: 'success'
                    });
                    //延迟秒
                    setTimeout(() => {
                        this.$emit('resolve');
                    }, 1000);
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>